import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import ProductHttpService from '../../services/product.http';

export function* GET({ payload }) {
  yield put({
    type: actions.product.SET_STATE,
    payload: {
      selected_product: null,
      loading: true
    }
  });

  const response = yield call(ProductHttpService.get, payload);
  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.product.SET_STATE,
        payload: {
          selected_product: response.data
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.product.SET_STATE,
    payload: { loading: false }
  });
}

export function* LIST({ payload }) {
  yield put({
    type: actions.product.SET_STATE,
    payload: {
      products: [],
      page: 1,
      loading: true
    }
  });

  const response = yield call(ProductHttpService.listOfEvent, payload);
  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.product.SET_STATE,
        payload: {
          ...response.data
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.product.SET_STATE,
    payload: { loading: false }
  });
}

export function* MORE_LIST({ payload }) {
  yield put({
    type: actions.product.SET_STATE,
    payload: {
      loading: true
    }
  });

  const { product } = yield select();
  payload = { ...payload, page: product.page + 1 };

  const response = yield call(ProductHttpService.listOfEvent, payload);
  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.product.SET_STATE,
        payload: {
          products: [...product.products, ...response.data.products],
          page: product.page + 1
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.product.SET_STATE,
    payload: { loading: false }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.product.GET, GET),
    takeEvery(actions.product.LIST, LIST),
    takeEvery(actions.product.MORE_LIST, MORE_LIST)
  ]);
}
